import { render, staticRenderFns } from "./ComplementaryQuestions.vue?vue&type=template&id=df68914c&scoped=true"
import script from "./ComplementaryQuestions.vue?vue&type=script&lang=js"
export * from "./ComplementaryQuestions.vue?vue&type=script&lang=js"
import style0 from "./ComplementaryQuestions.vue?vue&type=style&index=0&id=df68914c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df68914c",
  null
  
)

export default component.exports